import React from "react";
import { useTranslation } from 'react-i18next';

import './about.css';

import about_img from './diagram 1.png';
import { FaCheckCircle } from "react-icons/fa";


const About = () => {

    const { t } = useTranslation();

    return (
        <>

            <section id="about_section">

                <div id="about_img_div">
                    <img id="about_img" src={about_img} alt="" />
                </div>

                <div id="about_txt_div">
                    <h1 id="about_hdng">
                        {t('defaultPage_about.main_heading')}
                    </h1>

                    <p id="about_txt">
                        {t('defaultPage_about.subtext')}
                        <br /> {t('defaultPage_about.highlight')}
                    </p>
                    <span className="points">
                        <FaCheckCircle style={{ color: '#EF4723', fontSize: '17px', marginRight: '7px' }} />
                        {t('defaultPage_about.pointers.point 1')}
                    </span>
                    <span className="points">
                        <FaCheckCircle style={{ color: '#EF4723', fontSize: '17px', marginRight: '7px' }} />
                        {t('defaultPage_about.pointers.point 2')}
                    </span>
                    <span className="points">
                        <FaCheckCircle style={{ color: '#EF4723', fontSize: '17px', marginRight: '7px' }} />
                        {t('defaultPage_about.pointers.point 3')}
                    </span>
                    <span className="points">
                        <FaCheckCircle style={{ color: '#EF4723', fontSize: '17px', marginRight: '7px' }} />
                        {t('defaultPage_about.pointers.point 4')}
                    </span>
                </div>

            </section>

        </>
    );
};

export default About;